import { Component, inject, ViewChild } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { IconsService } from 'src/app/shared/services/icons.service';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import * as bs from 'bootstrap';
import { Refuel } from 'src/app/models/refuel.model';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { Settlement } from 'src/app/models/settlement.model';
import { ModalSetPriceComponent } from 'src/app/components/modals/modal-set-price.component';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { lastMonthDay } from 'src/app/shared/utils/utils';

@Component({
  selector: 'app-refuels',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Combustible</h1>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">        
        <ul #subnav app-nav-tanques [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        
        
        <div class="list-group rounded-4 rounded-md-5 ">
          <div class="list-group-item table-responsive py-3">
            <div class="d-flex mb-0">
              <div class="flex-fill ms-2">
                <h2 class="mt-2 mt-md-0 mb-0">Suministro de combustible</h2>
                <p class="text-muted mb-0" style="font-size: 14px;">Agrega pedidos asociados al condominio.</p>
              </div>
            </div>
          </div>
          <div class="list-group-item table-responsive py-4">
            <div class="d-flex">
              <div class="flex-fill ms-3 me-3">
                <div class="input-group mb-0">
                  <input class="form-control border-secondary border-end-0 rounded-start-3 bg-transparent" placeholder="Buscar..." [formControl]="search">
                  <div class="input-group-append border border-secondary border-start-0 rounded-end-3 bg-transparent">
                    <fa-icon [icon]="icons.faSearch" *ngIf="!search.value" class="input-group-text bg-transparent border-0 mt-1"></fa-icon>
                    <fa-icon [icon]="icons.faTimes" *ngIf="search.value" (click)="clearSearch()" class="input-group-text bg-transparent border-0 mt-1"></fa-icon>
                  </div>
                </div>
              </div>
              <div>
                <select class="form-select border-secondary rounded-3 bg-transparent" (change)="selectSettlement($event)">
                  <option selected [selected]="true" [value]="0">Condominio</option>
                  <option *ngFor="let settlement of settlements" [value]="settlement.id" >{{settlement.name}}</option>
                </select>
              </div>
              <div class="text-end">
                <button type="button" class="btn btn-zazz-dark ms-2 shadow-sm" (click)="setPrice()">
                  <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
                  Agregar precio
                </button>
              </div>
            </div>
          </div>
          <div class="list-group-item table-responsive py-4">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2">Folio</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Tanque</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Lts. Solicitados</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Lts. Suministrados</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Precio</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Solicitado</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Entrega</th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-right-3 py-2"></th>
                </tr>
              </thead>
              <tbody *ngIf="refuels!.length>0">
                <tr app-tr-refuel 
                  [refuel]="refuel" 
                  [profile]="profile" 
                  [permissions]="permissions"
                  (refuelSelected)="updateList($event)"
                  *ngFor="let refuel of refuels | paginate: { 
                    itemsPerPage: payload.per_page, 
                    currentPage: p, 
                    totalItems: meta.total_entries 
                  }"
                >
                </tr>
              </tbody>
            </table>
            <div class="text-center py-5" *ngIf="refuels?.length==0&&loading">
              <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
              <p class="text-muted">Cargando...</p>
            </div>
            <div class="text-center py-5" *ngIf="refuels?.length==0&&!loading" >
              <img src="/assets/images/empty-state.png" width="240px">
              <p class="text-muted">No se encontraron registros</p>
            </div>
          </div>
          <div class="list-group-item text-center pt-3">
            <pagination-controls
              (pageChange)="p = $event"
              (pageChange)="pageChanged($event)"
              previousLabel="Prev."
              nextLabel="Sig."
              screenReaderPaginationLabel="Pagination"
              screenReaderPageLabel="page"                  
            ></pagination-controls>
          </div>
        </div>
      </div>
    </div>
    <app-modal-set-price [refuelList]="refuelList" (priceData)="savePrice($event)"></app-modal-set-price>
  `,
  styleUrls: []
})
export class RefuelsComponent {
  @ViewChild(ModalSetPriceComponent, { static: true }) modalSetPriceComponent !: ModalSetPriceComponent;

  currentView: string = 'refuels';
  search: FormControl = new FormControl();

  loading: boolean = false;
  refuels: Refuel[] = [];
  settlements: Settlement[] = [];
  meta: any = {};
  refuelList: any[] = [];
  profile: any = {};
  permissions: any = {};

  payload: any = {
    page: 1,
    per_page: 50,
    created_at_since: '',
    created_at_to: '',
    sort: 'created_at',
    order: 'DESC'
  };

  p: number = 1;

  a = new Date();
  fromDate; // : any = "2023/12/01"; // Date = new Date();
  toDate; // : any = "2024/02/02"; // Date = new Date();
  storageService = inject(StorageService);
  constructor(
    private store : SettlementsService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    public icons: IconsService,
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
    this.payload.profile_id = this.profile ? this.profile.id : 0;

    this.fromDate = new NgbDate(this.a.getFullYear(), this.a.getMonth(), 1);
    this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, lastMonthDay(this.a.getFullYear(), this.a.getMonth()));
    //
    this.payload.created_at_since = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
    this.payload.created_at_to = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;
  }

  ngOnInit(): void {
    this.loadRefuels(this.payload);
    this.loadSettlements();
    
    this.search.valueChanges.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      switchMap((term: string) => {
        if (!term) {
          return this.store.queryRefuels({
            profile_id: this.payload.profile_id,
            page: 1,
            per_page: this.payload.per_page
          });
        } else {
          return this.store.queryRefuels({
            folio: term, 
            profile_id: this.payload.profile_id,
            page: 1,
            per_page: this.payload.per_page
          })
        }
      })).subscribe((data: any) => {
        this.refuels = data.data;
        this.meta = data.meta;
      });
  }

  loadRefuels(payload: any) {
    this.loading = true;
    this.store.queryRefuels(payload).subscribe({
      next: (refuels: any) => {
        this.refuels = refuels.data;
        this.meta = refuels.meta;
        this.loading = false;
      },
      error: (err: any) => {
        console.log("WTF", err.status);
        this.loading = false;
        this.refuels = [];
        if (err.status === 500) {
          this.toastr.error('Ocurrió un error al obtener las amenidades.', 'Error');
        }
      }
    });
  }

  loadSettlements() {
    let settlementPayload: any = {
      page: 1,
      per_page: 300,
      utility_id: this.profile.utility_id
    };
    this.store.getSettlements(settlementPayload).subscribe((data: any) => {
      this.settlements = data.data;
    });
  }

  selectSettlement(event: any) {
    if (event.target.value == 0) {
      delete this.payload.settlement_id;
    } else {
      this.payload.settlement_id = event.target.value;
    }
    this.loadRefuels(this.payload);
  }

  clearSearch() {
    delete this.payload.folio;
    this.search.setValue(null);    
    this.loadRefuels(this.payload);
  }

  pageChanged(event: any) {
    this.payload.page = event;
    this.loadRefuels(this.payload);
  }

  updateList(event: any) {
    if (event.checked) {
      this.refuelList.push(event.refuel.id);
    } else {
      this.refuelList = this.refuelList.filter((id: any) => id !== event.refuel.id);    
    }
  }

  setPrice() {
    const modalTemplate: any | undefined = this.modalSetPriceComponent;
    if (modalTemplate) {
      this.modalSetPriceComponent.openModal(modalTemplate['modalSetPrice']);
    }
  }

  savePrice(event: any) {
    this.store.setPrice({ list: this.refuelList, price: event.price }).subscribe({
      next: (res: any) => {
        console.log(res);
        this.toastr.success('Precio actualizado.');
        window.location.reload();
      },
      error: (err: any) => {
        console.log(err);
        this.toastr.error('Ocurrió un error al actualizar el precio.', 'Error');
      }
    });
  }
} 
